const globalVars = {}
export default globalVars;